import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
  draggableMenuItemOption: {
    backgroundColor: '#fff',
    transition: 'background-color 200ms ease-in-out',

    '&.dragging': {
      backgroundColor: '#f1f2f3',
    },
  },
}));

export default useStyles;
